module.exports = __webpack_public_path__ + "assets/logo.png";


//////////////////
// WEBPACK FOOTER
// ./Scripts/assets/images/logo.png
// module id = 914
// module chunks = 1